const requestList = [
  {
    code: "newsExpress",
    label: "新闻速递",
    prop: "newsList",
    list: [],
    isShow: null,
    default: true,
    id: null,
    pageNum: 1,
    pageSize: 6,
  },
  {
    code: "policiesRegulations", //请求对应的code
    label: "政策法规",
    prop: "newsList", //储存对应的数组名
    list: [], //储存的数据
    isShow: null, //显隐状态
    default: false, //首页默认展示
    id: null,
    pageNum: 1,
    pageSize: 6,
  },

  {
    code: "analysisReport",
    label: "分析报告",
    prop: "analysisList",
    list: [],
    isShow: null,
    default: true,
    id: null,
    pageNum: 1,
    pageSize: 4,
  },
  {
    code: "trainingLectures",
    label: "素养教育",
    prop: "trainingList",
    list: [],
    isShow: null,
    default: true,
    id: null,
    pageNum: 1,
    pageSize: 4,
  },
  {
    code: "competitionDynamics",
    label: "竞赛动态",
    prop: "trainingList",
    list: [],
    isShow: null,
    default: false,
    id: null,
    pageNum: 1,
    pageSize: 4,
  },
];
module.exports = {
  requestList,
};
